// @flow

import relayEnvironment from 'shared/gql/relayEnvironment';

const CURRENCY_SYMBOLS = {
  USD: '$',
  GBP: '£',
  EUR: '€',
};

const CURRENCY_LOCALES = {
  USD: 'en-US',
  GBP: 'en-GB',
  EUR: 'de-DE',
};

let _currency: string = 'USD';

/**
 * Set the company currency. Called once from the bootstrapper
 * after fetching the company data.
 */
export function setCompanyCurrency(currency: string) {
  _currency = currency || 'USD';
}

/**
 * Get the current company currency code (e.g. 'USD', 'GBP', 'EUR').
 */
export function getCompanyCurrency(): string {
  return _currency;
}

/**
 * Get the symbol for the current company currency.
 */
export function getCurrencySymbol(currency?: string): string {
  const code = currency || _currency;
  return CURRENCY_SYMBOLS[code] || '$';
}

/**
 * Format a numeric value as currency using the company's currency setting.
 * Uses Intl.NumberFormat for proper locale-aware formatting.
 *
 * @param value - The numeric value to format
 * @param currency - Optional override currency code (defaults to company setting)
 * @returns Formatted currency string (e.g. "$1,234.56", "£1,234.56", "€1.234,56")
 */
export function formatCurrency(value: ?number, currency?: string): string {
  const code = currency || _currency;
  const locale = CURRENCY_LOCALES[code] || 'en-US';

  if (value == null || isNaN(value)) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
    }).format(0);
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
  }).format(value);
}
